import { switcher, toID } from '../utils';
import { ACTIONS } from '../../const';
import { pageCompressor } from '../../page_compressor';
import env from '../../env';

import R from 'ramda';

const { TARGET } = env;

const tagSet = (tags = []) => tags.filter(t => t != '');

const convertFromServer = data => ({
    ...data,
    tags: tagSet(data.tags),
    section_id: TARGET == 'mlx' ? null : toID(data.section),
});

export default switcher(
    { origin: '' },
    {
        [ACTIONS.ADD_CONTENT](state, action) {
            if (
                action.manifest.media_type == 'text' &&
                action.manifest.is_finalized
            ) {
                // Don't accept broken manifests. We can't do anything with content
                // that doesn't have a TOC, pages, or image_base
                if (
                    action.manifest.TOC == null ||
                    action.manifest.pages == null ||
                    action.manifest.image_base == null
                ) {
                    return state;
                }
            }

            let manifest = convertFromServer(action.manifest);
            if (manifest.media_type == 'text' && manifest.is_finalized) {
                if (manifest.pages.length == 0) {
                    return state;
                }

                manifest = {
                    ...manifest,
                    pages: manifest.pages.map((page, index) =>
                        pageCompressor(manifest.pages, index)
                    ),
                };
            }

            return {
                ...state,
                [manifest.id]: manifest,
            };
        },
        [ACTIONS.DELETE_CONTENT](state, action) {
            const { content } = action.payload;

            return R.dissoc(String(content.id), state);
        },
        [ACTIONS.DELETE_COLLECTION](state, action) {
            const { section_id, name } = action.payload;

            const removeTagFromList = R.filter(t => t != name);

            const removeTagFromContent = R.over(
                R.lensProp('tags'),
                removeTagFromList
            );

            const updatecontent = content => {
                if (content.section_id == section_id) {
                    return removeTagFromContent(content);
                }
                return content;
            };

            return R.map(updatecontent, state);
        },
        [ACTIONS.ADD_CONTENT_TO_COLLECTION](state, action) {
            const { content_id, name } = action.payload;

            const lens = R.lensPath([content_id, 'tags']);
            const updateTag = R.append(name);

            return R.over(lens, updateTag, state);
        },
        [ACTIONS.REMOVE_CONTENT_FROM_COLLECTION](state, action) {
            const { content_id, name } = action.payload;

            const lens = R.lensPath([content_id, 'tags']);
            const updateTag = R.filter(t => t != name);

            return R.over(lens, updateTag, state);
        },
        [ACTIONS.SET_ORIGIN](
            state,
            { payload = window.location.hash.substr(1) }
        ) {
            return { ...state, origin: payload };
        },
    }
);



// WEBPACK FOOTER //
// ./src/reducers/content/content.js